import { render, staticRenderFns } from "./calendar-attributes-main.vue?vue&type=template&id=696bde1e&scoped=true"
import script from "./calendar-attributes-main.vue?vue&type=script&lang=js"
export * from "./calendar-attributes-main.vue?vue&type=script&lang=js"
import style0 from "./calendar-attributes-main.vue?vue&type=style&index=0&id=696bde1e&lang=scss&scoped=true"
import style1 from "./calendar-attributes-main.vue?vue&type=style&index=1&id=696bde1e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696bde1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\User\\Documents\\legalmerge-prod\\legal-merge\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('696bde1e')) {
      api.createRecord('696bde1e', component.options)
    } else {
      api.reload('696bde1e', component.options)
    }
    module.hot.accept("./calendar-attributes-main.vue?vue&type=template&id=696bde1e&scoped=true", function () {
      api.rerender('696bde1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin_settings/components/calendars/calendar-attributes-main.vue"
export default component.exports